import React, { useState, useEffect } from "react";
import "./Appointment.css";
import gsap from "gsap";
// OptimizedAPI supprimé

// Fonction pour extraire les credentials du token client
const getCredentialsFromToken = (token) => {
  try {
    const decoded = atob(token);
    const credentials = JSON.parse(decoded);
    return credentials;
  } catch (error) {
    console.error("❌ [Appointment] Erreur décodage token:", error);
    return {};
  }
};

const Appointment = ({ token, setCancel, setSuccess }) => {
  const [possibleRdv, setPossibleRdv] = useState([]);
  const [selectedRdv, setSelectedRdv] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [initialLoading, setInitialLoading] = useState(true);
  const [client, setClient] = useState(null);
  const [operationName, setOperationName] = useState("");

  const fetchAppointments = async () => {
    if (token) {
      setInitialLoading(true);
      
      const credentials = getCredentialsFromToken(token);
      
      try {
        const data = await fetch('/rdv/get-rdv-and-user-info-by-token', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            token,
            company_name: credentials.company_name,
            company_password: credentials.company_password,
          }),
        }).then(res => res.json());

        console.log("✅ [Appointment] Données reçues:", data);
        setInitialLoading(false);
        
        if (data && data.appointments && Array.isArray(data.appointments)) {
          // Limiter à 3 créneaux maximum pour correspondre au design
          setPossibleRdv(data.appointments.slice(0, 3));
          setError(null);
        } else {
          setPossibleRdv([]);
          setError(true);
        }
        
        if (data && data.client) {
          setClient(data.client);
          if (data.client.operation_name) {
            setOperationName(data.client.operation_name);
          }
        }
        
        if (data.error) {
          console.error("❌ [Appointment] API Error:", data.error);
          setError(true);
          setPossibleRdv([]);
        }
      } catch (error) {
        setInitialLoading(false);
        setError(true);
        console.error("❌ [Appointment] Request failed:", error);
        setPossibleRdv([]);
      }
    }
  };

  useEffect(() => {
    fetchAppointments();
  }, [token]);

  const sendRdv = async (rdv) => {
    if (rdv) {
      setLoading(true);
      console.log("🚀 [Appointment] Confirmation...");
      
      const credentials = getCredentialsFromToken(token);
      
      try {
        const data = await fetch("/rdv/confirm-appointment", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            rdv,
            token,
            client,
            company_name: credentials.company_name,
            company_password: credentials.company_password,
          }),
        }).then(res => res.json());

        if (data.error) {
          console.error("❌ [Appointment] Confirmation error:", data.error);
          setError(true);
          setLoading(false);
        } else {
          console.log("✅ [Appointment] Confirmation réussie!");
          setSuccess(true);
          setLoading(false);
        }
      } catch (error) {
        console.error("❌ [Appointment] Confirmation failed:", error);
        setError(true);
        setLoading(false);
      }
    }
  };

  const handleRdvClick = (rdv) => {
    setSelectedRdv(rdv);
  };

  const handleValidate = () => {
    if (selectedRdv) {
      sendRdv(selectedRdv);
    }
  };

  const handleCancel = () => {
    setSelectedRdv(null);
    const transition = gsap.timeline();
    transition.to(".appointment-container", {
      opacity: 0,
      duration: 0.3,
      ease: "power1.in",
      onComplete: () => {
        setCancel(true);
      },
    });
  };

  const handleRetry = () => {
    setError(null);
    setPossibleRdv([]);
    fetchAppointments();
  };

  const handleContact = () => {
    // Vous pouvez ajouter ici la logique pour contacter le support
    window.location.href = "mailto:support@monagora.com?subject=Question sur la réservation";
  };

  // Fonctions utilitaires pour le formatage
  const getBackToHours = (timeSlot, baseHour = 8) => {
    const minutes = (timeSlot * 15) % 60;
    const hourOffset = Math.floor((timeSlot * 15) / 60);
    const hour = baseHour + hourOffset;
    return `${hour}h${minutes === 0 ? "00" : minutes}`;
  };

  const formatToStandard = (dateString) => {
    const date = new Date(dateString);
    const days = [
      "Dimanche",
      "Lundi", 
      "Mardi",
      "Mercredi",
      "Jeudi",
      "Vendredi",
      "Samedi",
    ];
    const months = [
      "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
      "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre",
    ];

    const dayName = days[date.getDay()];
    const dayNumber = date.getDate();
    const monthName = months[date.getMonth()];

    return `${dayName} ${dayNumber} ${monthName}`;
  };

  const renderRdvCard = (rdv, index) => {
    const isSelected = selectedRdv === rdv;
    
    return (
      <div
        key={index}
        className={`rdv-card ${isSelected ? "selected" : ""}`}
        onClick={() => handleRdvClick(rdv)}
      >
        <div className="card-choice-title">CHOIX {index + 1}:</div>
        <div className="choice-divider"></div>
        <div className="card-day">{formatToStandard(rdv.date)}</div>
        <div className="card-time">{getBackToHours(rdv.beginning)}</div>
      </div>
    );
  };

  const renderLoadingSpinner = () => (
    <div className="loading-container">
      <div className="spinner"></div>
    </div>
  );

  const renderErrorMessage = () => (
    <div className="error-message">
      <span className="error-icon">ℹ️</span>
      <h2 className="error-title">Aucun créneau trouvé</h2>
      <p className="error-description">
        Nous n'avons pas pu récupérer vos créneaux de rendez-vous pour le moment.
        <br />
        Veuillez réessayer ou nous contacter si le problème persiste.
      </p>
      <div className="error-actions">
        <button onClick={handleRetry} className="retry-button">
          Réessayer
        </button>
        <button onClick={handleContact} className="contact-button">
          Nous contacter
        </button>
      </div>
    </div>
  );

  // Si on est en train de charger initialement, afficher juste le spinner
  if (initialLoading) {
    return (
      <div className="appointment-container">
        <div className="header-wrapper">
          <div className="logo-container">
            <h1 className="logo-text">MonAgora</h1>
          </div>
        </div>
        {renderLoadingSpinner()}
      </div>
    );
  }

  // Si il y a une erreur, afficher le message d'erreur
  if (error) {
    return (
      <div className="appointment-container">
        <div className="header-wrapper">
          <div className="logo-container">
            <h1 className="logo-text">MonAgora</h1>
          </div>
        </div>
        {renderErrorMessage()}
      </div>
    );
  }

  // Si on a des créneaux, afficher la sélection
  if (possibleRdv.length > 0) {
    return (
      <div className="appointment-container">
        <div className="header-wrapper">
          <div className="logo-container">
            <h1 className="logo-text">MonAgora</h1>
          </div>
        </div>
        
        <div className="content-wrapper">
          <div className="welcome-section">
            <h2 className="welcome-title">Bienvenue !</h2>
            <p className="welcome-subtitle">
              Voici les créneaux disponibles pour votre rendez-vous
            </p>
            {operationName && (
              <p className="operation-name">Opération : {operationName}</p>
            )}
          </div>

          <div className="choices-section">
            <h3 className="choices-title">Choisissez votre créneau :</h3>
            <div className="choices-grid">
              {possibleRdv.map((rdv, index) => renderRdvCard(rdv, index))}
            </div>
          </div>

          <div className="actions-section">
            <button
              onClick={handleValidate}
              disabled={!selectedRdv || loading}
              className={`validate-button ${!selectedRdv ? "disabled" : ""}`}
            >
              {loading ? "Confirmation..." : "Confirmer le rendez-vous"}
            </button>
            
            <button onClick={handleCancel} className="cancel-button">
              Annuler
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Fallback
  return (
    <div className="appointment-container">
      <div className="header-wrapper">
        <div className="logo-container">
          <h1 className="logo-text">MonAgora</h1>
        </div>
      </div>
      {renderErrorMessage()}
    </div>
  );
};

export default Appointment; 